import { Divider, Group, Stack, Text } from '@mantine/core'
import { BOGGLE_GOLD_TILE_KIND } from '~/boggle/engine/specialTiles'
import { ChallengeSpecialTilePreview } from '~/boggle/ui/challenge/ChallengeSpecialTilesSection'

export function RaceHowToPlay() {
  return (
    <Stack gap={20} mb={10} w={290} align="center" ff="Tilt Neon, sans-serif">
      <Stack gap={30}>
        <Stack gap={6} bdrs={8} w="100%">
          <Text fz={20} opacity={1} w="100%" ta="center" lh={1}>
            Form words to clear tiles
          </Text>
          <Text fz={16} opacity={0.8} lh={1.2} w="100%" ta="center">
            Each tile cleared scores{' '}
            <Text span c="yellow" fw={600} fz={18} ml={2}>
              +1
            </Text>
          </Text>
        </Stack>
        <Stack
          px={20}
          py={16}
          bd="1px solid rgba(255, 255, 255, 0.1)"
          bg="rgba(0, 0, 0, 0.1)"
          bdrs={8}
          w="100%"
          gap={4}
          align="center"
        >
          <Text fz={20} opacity={1} lh={1.2} w="100%" ta="center">
            Fill your{' '}
            <Text span c="#f6dd8a" fz={20}>
              bonus
            </Text>{' '}
            meter
          </Text>
          <Divider
            maw={190}
            ta="center"
            opacity={0.7}
            my={8}
            c="white"
            color="rgba(255, 255, 255, 0.2)"
            label="To earn more gold tiles"
            w="100%"
            styles={{
              label: {
                fontSize: 13,
              },
            }}
          ></Divider>
          <Text
            fz={16}
            opacity={1}
            lh={1.3}
            w="100%"
            ta="center"
            c="rgba(255, 255, 255, 0.8)"
          >
            Play{' '}
            <Text span fw={600} c="white" mx={2}>
              Long Words
            </Text>
            {' and '}
            <Text span fw={600} c="white">
              Uncommon&nbsp;Letters
            </Text>
          </Text>
          {/* <Text
            mt={10}
            fz={13}
            lh={1.3}
            maw={180}
            ta="center"
            opacity={0.5}
            c="white"
          >
            A full meter will cause more gold tiles to appear.
          </Text> */}
          <Stack justify="center" align="center" w="100%" gap={0} mt={10}>
            <ChallengeSpecialTilePreview kind={BOGGLE_GOLD_TILE_KIND} previewLetter="A" />
            <Stack
              gap={0}
              align="center"
              pt={6}
              pb={12}
              // bd="1px solid rgba(255, 255, 255, 0.1)"
              // bg="rgba(0, 0, 0, 0.1)"
            >
              <Text fz={16} opacity={0.8} lh={1.2} w="100%" ta="center">
                Gold tiles score{' '}
                <Text span c="yellow" fw={600} fz={18} ml={2}>
                  +1
                </Text>
              </Text>
              <Text span fw={400} c="orange.2" fz={13} opacity={1}>
                For every usage
              </Text>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
